import dashboardRequest from '@/pages/dashboard/utils/dashboardRequest';

// 获取世界时钟数据
export const getWorldClock: (data: any) => Promise<any> = (data) => {
    const options = {
        url: '/api/v1/dashboard/timezone/getWorldClock',
        method: 'post',
        data: data,
    }
    return dashboardRequest(options)
};
// 保存用户选择的世界时钟
export const saveWorldClock: (data: any) => Promise<any> = (data) => {
    const options = {
        url: '/api/v1/dashboard/timezone/saveWorldClock',
        method: 'post',
        data: data,
    }
    return dashboardRequest(options)
};

// Daily by Timezone 页面 指标趋势图
export const getByTimeZoneTrendData: (data: any) => Promise<any> = (data) => {
    const options = {
        url: '/api/v1/dashboard/multi_timezone/daily/linechart',
        method: 'post',
        data: data,
    }
    return dashboardRequest(options)
};


// Daily by Timezone 页面 宽表下载
export const downLoadDailyByTimezonePerformanceTable: (data: any, language:string) => Promise<any> = (data, language) => {
    const options = {
        url: `/api/v1/dashboard/multi_timezone/daily/overall_performance/download?language=${language}`,
        method: 'post',
        data: data,
        rawData:true,
        responseType: 'arraybuffer',
        ignoreRequestId : false
    }
    return dashboardRequest(options)
};


// 获取Daily by Timezone 页面 宽表数据
export const getDailyByTimezonePerformanceTable: (data: any, language:string) => Promise<any> = (data, language) => {
    const options = {
        url: `/api/v1/dashboard/multi_timezone/daily/overall_performance?language=${language}`,
        method: 'post',
        data: data,
        ignoreRequestId : false
    }
    return dashboardRequest(options)
};

// 热力图下载
export const downLoadNewUsersRetentionByTimezoneTable: (data: any, language:string) => Promise<any> = (data, language) => {
  const options = {
    url: `/api/v1/dashboard/multi_timezone/retention/overall_performance/download?language=${language}`,
    method: 'post',
    data: data,
    rawData:true,
    responseType: 'arraybuffer',
    ignoreRequestId : false
  }
  return dashboardRequest(options)
};


// 获取热力图数据
export const getNewUsersRetentionByTimezoneTable: (data: any, language:string) => Promise<any> = (data, language) => {
  const options = {
    url: `/api/v1/dashboard/multi_timezone/retention/overall_performance?language=${language}`,
    method: 'post',
    data: data,
    ignoreRequestId : false
  }
  return dashboardRequest(options)
};


//  metrics 模块
export const loadWeeklyMetricsTrend: (data: any) => Promise<any> = (data) => {
    const options = {
        url: '/api/v1/dashboard/overview_week/metrics_trend',
        method: 'post',
        data: data,
    }
    return dashboardRequest(options)
};








